/**
 *
 * Tag
 *
 */

import PropTypes from 'prop-types';
import React, { forwardRef, memo } from 'react';

import { Component } from './Tag.styles';
import CrossIcon from '../../../assets/v2/CrossIcon';

// Ref is forwarded so consumers can anchor a Tooltip (or measure overflow) on
// the chip itself rather than on a wrapper element.
const Tag = forwardRef((props, ref) => (
  <Component ref={ref} deleteIcon={<CrossIcon />} {...props} />
));

Tag.displayName = 'Tag';

Tag.propTypes = {
  icon: PropTypes.node,
  // A node, not just a string, so consumers can pass a measurable label element.
  label: PropTypes.node,
  onDelete: PropTypes.func,
};

export default memo(Tag);
